function Shadow() {
  return <section className="w-full h-1 shadow"></section>;
}

export default Shadow;
